import { Box, Paper, PaperProps, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface IntegrationCardWrapperProps {
  name: string;
  logo?: string;
  rightActions?: ReactNode;
  leftActions?: ReactNode;
  paperProps?: PaperProps;
  size?: 'small' | 'large';
  isDisabled?: boolean;
  secondaryDetails?: ReactNode;
}

export const IntegrationCardWrapper = ({
  name,
  logo,
  rightActions = null,
  leftActions = null,
  paperProps = {},
  size = 'large',
  isDisabled = false,
  secondaryDetails = null,
}: IntegrationCardWrapperProps) => {
  const paperStyleProps = paperProps.sx;
  const isLargeSize = size === 'large';

  return (
    <Paper
      variant="outlined"
      {...paperProps}
      sx={{
        borderRadius: isLargeSize ? 4 : 2,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'divider',
        ...paperStyleProps,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        height={isLargeSize ? '110px' : '90px'}
        px={isLargeSize ? 4 : 3}
      >
        <Stack alignItems="center" direction="row" spacing={0.5}>
          <Stack
            spacing={2}
            alignItems="center"
            direction="row"
            sx={{ opacity: isDisabled ? 0.5 : 1 }}
          >
            {logo && (
              <Box component="img" src={logo} width={isLargeSize ? 35 : 30} />
            )}
            <Stack>
              <Typography variant={isLargeSize ? 'body1' : 'body2'}>
                {name}
              </Typography>
              {secondaryDetails}
              {isDisabled && (
                <Typography variant="body2">Integration Disabled</Typography>
              )}
            </Stack>
          </Stack>
          <Box>{leftActions}</Box>
        </Stack>
        <Box>{rightActions}</Box>
      </Stack>
    </Paper>
  );
};
